import { useEffect, useState } from "react";
import { Badge, Nav, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { BadgeCount } from "../../model/datatype";
import Lottie from "react-lottie";
import * as errorDialog from "../../../src/assets/images/error-dialog.json";
import { appConfig } from "../../authConfig";
import { LuLogOut, LuBoxes, LuFileKey } from "react-icons/lu";
import { clearPermissionCache } from "../../services/PermissionGroup";

export const Sidemenu = (props: any) => {
  const [pathname, setPathname] = useState("/");
  const location = useLocation();
  const date = new Date(); // date object
  const getYear = date.getFullYear(); // get current year
  const getMonth = date.getMonth() + 1; // get current year
  const [advSalaryRequest, setAdvSalaryRequest] = useState<BadgeCount | null>(
    null
  );
  const hostname: string = window.location.pathname;

  const errorDialogOptions = {
    loop: true,
    autoplay: true,
    animationData: errorDialog,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  useEffect(() => {
    localStorage.setItem("Language", "en");
    setPathname(location.pathname);
  }, [location]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    clearPermissionCache(); // ล้าง permission cache เพื่อความปลอดภัย
    window.location.href =
      "https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=" +
      appConfig.appEndpoint.baseLocation;
  };

  function nFormatter(num: number) {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
    }
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    }
    return num;
  }

  return (
    <>
      {props?.displayFullScreenLoading && (
        <div className="full-screen-overlay">
          <div className="loading"></div>
        </div>
      )}

      <div className="side-bar-menu">
        <div className="brand-logo">
          <h1>Uniform Survey</h1>
          {props.subTitle ? (
            <>
              <div className="subTitileLogo">{props.subTitle}</div>
            </>
          ) : (
            <></>
          )}
        </div>
        <ul>
          {hostname.includes("backoffice") ? (
            <>
            
              <li
                className={`${
                  pathname === "/backoffice/uniform-dashboard" ||
                  pathname === "/backoffice/uniform-dashboard"
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/backoffice/uniform-dashboard">
                  <img src="../../../images/backoffice/home.png" />
                  Dashboard
                </Link>
              </li>
              <li
                className={`${
                  pathname === "/backoffice/uniform-summay" ? "active" : ""
                }`}
              >
                <Link to="/backoffice/uniform-summay">
                  <img src="../../../images/backoffice/message-square.png" />
                  Summary{" "}
                </Link>
              </li>
              <li
                className={`${
                  pathname === '/backoffice/uniform-upload-benefit' ? 'active' : ''
                }`}
              >
                <Link to="/backoffice/uniform-upload-benefit">
                  <img src="../../../images/backoffice/upload-cloud.png" />
                  UploadBenefit{' '}
                </Link>
              </li>
              <li
                className={`${
                  pathname === '/backoffice/uniform-schedulers' ? 'active' : ''
                }`}
              >
                <Link to="/backoffice/uniform-schedulers">
                  <img src="../../../images/backoffice/message-square.png" />
                  Schedulers
                </Link>
              </li>
            </>
          ) : (
            <></>
          )}
          <li onClick={() => handleLogout()}>
            <a href="#">
              {/* <img src="../../../images/backoffice/log-out.png" /> */}
              <LuLogOut size={22} />
              <span style={{ padding: "4px" }}>Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};
